export var Lang = /*#__PURE__*/function (Lang) {
  Lang["Ru"] = "ru";
  Lang["En"] = "en";
  return Lang;
}({});
var subs = [];
var config = {};
export var configure = function configure(newConfig) {
  Object.assign(config, newConfig);
  subs.forEach(function (sub) {
    sub(config);
  });
};
export var subscribeConfigure = function subscribeConfigure(sub) {
  subs.push(sub);
  return function () {
    subs = subs.filter(function (item) {
      return item !== sub;
    });
  };
};
export var getConfig = function getConfig() {
  return config;
};
// #sourceMappingURL=configure.js.map